// 正整数（不允许负数和小数点）
export const positiveInteger = {
	// 定义过滤函数
	inserted(el, binding) {
		const input = el.querySelector('input')
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value) {
			return value.replace(/[^0-9]/g, '')
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用和过滤函数，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}

// 正数（允许小数，最多两位）
export const positiveNumber = {
	inserted(el, binding) {
		const input = el.querySelector('input')
		const decimalPlaces = parseInt(binding.arg) || 2 // 默认两位小数
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value) {
			let result = value.replace(/[^\d.]/g, '')
			const parts = result.split('.')
			if (parts.length > 2) {
				result = parts[0] + '.' + parts[1]
			} else if (parts.length === 2) {
				result = parts[0] + '.' + parts[1].slice(0, decimalPlaces)
			}
			return result
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用和过滤函数，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}

// 整数（允许负数）
export const integer = {
	inserted(el, binding) {
		const input = el.querySelector('input')
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value) {
			let result = value.replace(/[^-\d]/g, '')
			if (result.indexOf('-') > 0) {
				result = result.replace(/-/g, '')
			}
			if ((result.match(/-/g) || []).length > 1) {
				result = '-' + result.replace(/-/g, '')
			}
			return result
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用和过滤函数，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}

// 数字（允许负数和小数）
export const number = {
	inserted(el, binding) {
		const input = el.querySelector('input')
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value) {
			let result = value.replace(/[^-\d.]/g, '')
			if (result.indexOf('-') > 0) {
				result = result.replace(/-/g, '')
			}
			if ((result.match(/-/g) || []).length > 1) {
				result = '-' + result.replace(/-/g, '')
			}
			const parts = result.split('.')
			if (parts.length > 2) {
				result = parts[0] + '.' + parts[1]
			} else if (parts.length === 2) {
				result = parts[0] + '.' + parts[1].slice(0, 2)
			}
			return result
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用和过滤函数，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}

// 限制最大输入字符长度
export const maxLength = {
	inserted(el, binding) {
		const input = el.querySelector('input')
		const maxLength = binding.value || 20
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value, maxLen) {
			return value.length > maxLen ? value.substring(0, maxLen) : value
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue, maxLength)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用、过滤函数和最大长度，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._maxLength = maxLength
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		const maxLength = binding.value || el._maxLength || 20
		el._maxLength = maxLength

		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue, maxLength)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}

// 只能输入1-10的正整数
export const oneToTenInteger = {
	inserted(el, binding) {
		const input = el.querySelector('input')
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value) {
			// 先过滤非数字字符
			let result = value.replace(/[^0-9]/g, '')
			// 若输入为空，不做处理
			if (result === '') return result
			// 将输入值转换为数字
			const num = parseInt(result, 10)
			// 若数字小于1，设为1；若大于10，设为10
			if (num < 1) {
				result = '1'
			} else if (num > 10) {
				result = '10'
			} else {
				// 截取第一个数字
				result = String(num).charAt(0)
			}
			return result
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用和过滤函数，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}

// 只能输入1-100的正整数
export const oneToHundredInteger = {
	inserted(el, binding) {
		const input = el.querySelector('input')
		let composing = false // 添加中文输入法状态标记

		// 定义过滤函数
		const filterValue = function(value) {
			// 先过滤非数字字符
			let result = value.replace(/[^0-9]/g, '')
			// 若输入为空，不做处理
			if (result === '') return result
			// 将输入值转换为数字
			const num = parseInt(result, 10)
			// 若数字小于1，设为1；若大于100，设为100
			if (num < 1) {
				result = '1'
			} else if (num > 100) {
				result = '100'
			} else {
				// 保留完整数字
				result = String(num)
			}
			return result
		}

		// 添加过滤处理函数
		const handleInput = function() {
			// 如果是中文输入法正在输入中，则不进行过滤
			if (composing) return

			const oldValue = this.value
			const newValue = filterValue(oldValue)
			// 只有在值发生变化时才更新，避免光标位置重置
			if (oldValue !== newValue) {
				this.value = newValue
				// 触发input事件，确保v-model更新
				this.dispatchEvent(new Event('input'))
			}
		}

		// 监听中文输入法事件
		input.addEventListener('compositionstart', function() {
			composing = true
		})

		input.addEventListener('compositionend', function() {
			composing = false
			// 在输入法结束后进行一次过滤
			handleInput.call(this)
		})

		// 监听多种输入事件
		input.addEventListener('input', handleInput)
		input.addEventListener('change', handleInput)
		input.addEventListener('paste', function(e) {
			setTimeout(handleInput.bind(this), 0)
		})

		// 保存处理函数引用和过滤函数，以便在update和unbind时使用
		el._handleInput = handleInput
		el._filterValue = filterValue
		el._compositionHandler = {
			start: function() {
				composing = true
			},
			end: function() {
				composing = false
				handleInput.call(input)
			}
		}
	},
	// 当绑定的值更新时也进行过滤
	update(el, binding) {
		const input = el.querySelector('input')
		if (input.value && el._filterValue) {
			const oldValue = input.value
			const newValue = el._filterValue(oldValue)
			if (oldValue !== newValue) {
				input.value = newValue
				// 触发input事件，确保v-model更新
				input.dispatchEvent(new Event('input'))
			}
		}
	},
	// 解绑时移除事件监听
	unbind(el) {
		const input = el.querySelector('input')
		if (input && el._handleInput) {
			input.removeEventListener('input', el._handleInput)
			input.removeEventListener('change', el._handleInput)
			input.removeEventListener('paste', el._handleInput)

			// 移除中文输入法相关事件监听
			if (el._compositionHandler) {
				input.removeEventListener('compositionstart', el._compositionHandler.start)
				input.removeEventListener('compositionend', el._compositionHandler.end)
			}
		}
	}
}
